/* Toprank — rolling-digit "odometer" price on the buy-box Add-to-Cart button
   (design card "Product Options.html", step 5). Progressive enhancement:
   the theme's own [data-price-display] span inside .tl-buybox .x-atc-text keeps
   getting rewritten by variant/fee JS as usual; we visually hide it (a11y text
   stays) and mirror its text into a .tl-odo sibling where each digit lives in a
   clipped 1em column that rolls to the new value. Styles in secondary-css. */
(function () {
  if (window.__tlOdometerInit) return;
  window.__tlOdometerInit = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DIGIT = /[0-9]/;

  function render(odo, text, animate) {
    var prev = odo.__tlText || '';
    if (text === prev) return;
    odo.__tlText = text;

    var chars = text.split('');
    var prevChars = prev.split('');
    // align with the previous value from the RIGHT so the cents keep rolling
    // in place when the integer part gains/loses a digit
    var offset = chars.length - prevChars.length;

    odo.textContent = '';
    var pending = [];
    chars.forEach(function (ch, i) {
      if (DIGIT.test(ch)) {
        var col = document.createElement('span');
        col.className = 'tl-odo-col';
        var strip = document.createElement('span');
        strip.className = 'tl-odo-strip';
        for (var n = 0; n <= 9; n++) {
          var s = document.createElement('span');
          s.textContent = n;
          strip.appendChild(s);
        }
        var from = ch;
        var p = prevChars[i - offset];
        if (animate && !REDUCED && p != null && DIGIT.test(p)) from = p;
        strip.style.transform = 'translateY(-' + from + 'em)';
        col.appendChild(strip);
        odo.appendChild(col);
        if (from !== ch) pending.push([strip, ch]);
      } else {
        var st = document.createElement('span');
        st.textContent = ch === ' ' ? ' ' : ch;
        odo.appendChild(st);
      }
    });
    if (pending.length) {
      void odo.offsetWidth; // commit the "from" position, then roll
      pending.forEach(function (pair) {
        pair[0].style.transform = 'translateY(-' + pair[1] + 'em)';
      });
    }
  }

  function attach(buybox) {
    function sync(animate) {
      var price = buybox.querySelector('.x-atc-text [data-price-display]');
      if (!price) return;
      var odo = price.__tlOdo;
      if (!odo || !odo.isConnected || odo.previousElementSibling !== price) {
        odo = document.createElement('span');
        odo.className = 'tl-odo';
        odo.setAttribute('aria-hidden', 'true');
        price.insertAdjacentElement('afterend', odo);
        price.__tlOdo = odo;
        price.classList.add('tl-odo-src');
        animate = false; // fresh node (first paint or re-rendered form): no roll
      }
      render(odo, (price.textContent || '').trim(), animate);
    }

    sync(false);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType === 3) t = t.parentNode;
        if (t && t.closest && t.closest('.tl-odo')) continue; // our own writes
        sync(true);
        return;
      }
    }).observe(buybox, { subtree: true, childList: true, characterData: true });
  }

  function init() {
    document.querySelectorAll('.tl-buybox').forEach(attach);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shared helper: other scripts (e.g. the free-shipping meter in
  // snippets/product-free-shipping-meter.liquid) roll their own amounts
  // by calling window.tlOdo.render(el, '$50.00', true).
  window.tlOdo = { render: render };
})();
